var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompensate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6903 6.19153L23.4093 0.570651C23.2532 0.303285 22.9966 0.108555 22.6968 0.0312817C22.3985 -0.0429009 22.0786 0.000372216 21.8128 0.159556L11.7827 6.17762L26.6903 6.19153Z",
    fill: "#0076FE",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63642 7.72307C3.78641 7.72307 3.09094 7.02761 3.09094 6.1776C3.09094 5.32759 3.78641 4.63213 4.63642 4.63213H9.84465L15.0065 1.54119H4.63642C2.34912 1.54119 0.448187 3.2103 0.0772736 5.40487C0.0463642 5.5285 0 5.65214 0 5.79123V29.3597C0 31.9097 2.08639 33.9961 4.63642 33.9961H30.9094C32.6095 33.9961 34.0004 32.6052 34.0004 30.9051V27.8142H30.1367C26.3039 27.8142 23.1821 24.6924 23.1821 20.8596C23.1821 17.0268 26.3039 13.905 30.1367 13.905H34.0004V10.814C34.0004 9.114 32.6095 7.72307 30.9094 7.72307H4.63642ZM29.364 4.63213C29.364 3.07121 28.2049 1.77301 26.6903 1.5721L29.364 6.1776V4.63213Z",
    fill: "#0076FE",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9322 16.2235H30.1367C27.5805 16.2235 25.5003 18.3038 25.5003 20.86C25.5003 23.4162 27.5805 25.4964 30.1367 25.4964H35.9322C36.572 25.4964 37.0913 24.9771 37.0913 24.3373V17.3827C37.0913 16.7428 36.572 16.2235 35.9322 16.2235ZM30.1367 22.4054C29.2836 22.4054 28.5912 21.7131 28.5912 20.86C28.5912 20.0069 29.2836 19.3145 30.1367 19.3145C30.9898 19.3145 31.6822 20.0069 31.6822 20.86C31.6822 21.7131 30.9898 22.4054 30.1367 22.4054Z",
    fill: "#0076FE",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompensate);
export default __webpack_public_path__ + "static/media/compensate.5e8fbf231ec449e667cccc5de5fecd8d.svg";
export { ForwardRef as ReactComponent };